// extracted by mini-css-extract-plugin
export default {"dropdown":"SortOverlay_dropdown__gs7Ws"};